export const HOME_ROUTE = "/home";

export const BLOCK_TYPES = {
  CONTENT_LIST: "content_list",
  PAGE: "page",
  SECTION: "section",
};

export const ROW_TYPES = {
  CE_CROWN: "ceCrown",
  CE_CLIP: "ceClip",
  CHALLENGES: "challenges",
  EXPANDABLE_STANDARD: "ceExpandableStandard",
  KP_MULTI_ENTITY: "kp-multi-entity",
  VIDEO_CE_CLIP: "videoCEClip",
  TWO_COLUMN_ROW: "high-density-row",
  PREMIUM_CONTAINER: "premium-container",
};

export const LIST_STYLE = {
  HERO: "first-item-hero",
  VIDEO: "video-only",
  NO_SEE_MORE_LINK: "no-see-more-link",
};
